import { Outlet, useNavigation } from 'react-router-dom';

import { WorkspaceSkeleton } from '@/app/layouts';
import { FloatingOverlayHost, HintHost } from '@/shared/ui/primitives';

export function RootLayout() {
  const navigation = useNavigation();
  const showOverlay = navigation.state === 'loading';

  return (
    <FloatingOverlayHost>
      <Outlet />
      {showOverlay && (
        <div className="pointer-events-none fixed inset-0 z-50" aria-hidden="true">
          <WorkspaceSkeleton />
        </div>
      )}
      <HintHost />
    </FloatingOverlayHost>
  );
}
